export const Footer = () => (
    <p className="clearfix mb-0">
    </p>
  );

